import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import FeedbackPopup from '../AIInterviewEnrolledCourse/Feedback';

const AIInterviewResultUnenrolledCourse = () => {
  const { courseName, experience } = useParams();
  const navigate = useNavigate();

  const userId = localStorage.getItem('userId');
  const fullName = localStorage.getItem("fullName");
  const reportScores = localStorage.getItem(`reportScores-${courseName}-${experience}-${userId}`) ? JSON.parse(localStorage.getItem(`reportScores-${courseName}-${experience}-${userId}`)) : { result: 'Fail', accuracy: '0.00%', correctAnswers: 0, incorrectAnswers: 15, totalQuestions: 15 };
  const interviewId = localStorage.getItem(`${courseName}-interviewId`);
  const email = localStorage.getItem('email');

  const [showFeedbackPopup, setShowFeedbackPopup] = useState(true);

  const [isOnlyQuizInterview, setIsOnlyQuizInterview] = useState(false);

  const handleClosePopup = () => {
    setShowFeedbackPopup(false);
  };

  useEffect(() => {
    if (!sessionStorage.getItem("hasVisited")) {
      sessionStorage.setItem("hasVisited", "true");
      window.location.reload();
    } else {
      sessionStorage.removeItem("hasVisited");
    }
  }, []);


  useEffect(() => {
    const targetLanguages = ["python", "c", "c++", "java"];
  
    const escapeRegex = (str) =>
      str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); 
  
    const courseNameLower = courseName.toLowerCase();
  
    const match = targetLanguages.some((lang) => {
      const escapedLang = escapeRegex(lang.toLowerCase());
      const regex = new RegExp(`\\b${escapedLang}\\b`, 'i');
      return regex.test(courseNameLower);
    });
  
    if (courseName && match) {
      setIsOnlyQuizInterview(false);
    } else {
      setIsOnlyQuizInterview(true);
    }
  }, [courseName]);

  return (
    <div className="result-container">
      {
        isOnlyQuizInterview ? <h2>{reportScores.result === 'Pass' ? 'Congratulations!' : 'Better luck next time!'}</h2>
          : <h2>{reportScores.finalResult === 'Pass' ? 'Congratulations!' : 'Better luck next time!'}</h2>
      }
      <div className="profile-section">
        <div className="details">
          <p><strong>Name:</strong> {fullName || 'Guest'}</p>
          <p><strong>Interview Type:</strong> AI Technical</p>
          {
            reportScores?.result && (
              <>
                <h4>Interview Results (Audio-Based)</h4>
                <p><strong>Confidence Feedback:</strong> {reportScores.confidenceFeedback}
                  <span>
                    <Link to={`/${courseName}-${experience}/interview-confidence-level`} className="interview-btn-link">
                      (Know How AI Checks Confidence Level)
                    </Link>
                  </span>
                </p>

                <p><strong>Accuracy:</strong> {reportScores.accuracy}
                  <span>
                    <Link to={`/${courseName}-${experience}/interview-accuracy`} className="interview-btn-link">
                      (Know How AI Checks Accuracy)
                    </Link>
                  </span>
                </p>

                <p><strong>Correct Answers:</strong> {reportScores.correctAnswers}</p>
                <p><strong>Incorrect Answers:</strong> {reportScores.incorrectAnswers}</p>
                {
                  isOnlyQuizInterview && <p><strong>Result:</strong> {reportScores.result}</p>
                }
              </>
            )
          }

          {
            reportScores?.isFailed && (
              <>
                <h4>Coding Interview Results</h4>
                <p><strong>Result:</strong> {reportScores?.message}</p>

              </>
            )
          }

          {reportScores?.finalResult && (
            <>
              <h4>Coding Interview Results</h4>

              <p><strong>Correct Coding Answers:</strong> {reportScores.correctCodingAnswers}</p>
              <p><strong>Incorrect Coding Answers:</strong> {reportScores.incorrectCodingAnswers}</p>
              <p><strong>Coding Accuracy:</strong> {reportScores.codingAccuracy}</p>
              <p><strong>Result:</strong> {reportScores.finalResult}</p>
            </>
          )
          }

          {showFeedbackPopup && (
            <FeedbackPopup
              interviewId={interviewId}
              userId={userId}
              userName={fullName}
              userEmail={email}
              onClose={handleClosePopup} 
            />
          )}
        </div>
      </div>

      <div className="interview-result-btn-container">
        <button className="certificate-btn" onClick={() => navigate(`/unenrolled-ai-interview/${courseName}/${experience}`)}>
          Retake the exam
        </button>
        <button className="certificate-btn" onClick={() => navigate("/")}>Go to Home</button>
      </div>
    </div>
  );
};

export default AIInterviewResultUnenrolledCourse;
